import type { ReactNode } from 'react';
import { inputClass } from '../fieldWork/FormModal';

export function DateRangeInputs({ from, to, setFrom, setTo }: {
  from: string; to: string; setFrom: (v: string) => void; setTo: (v: string) => void;
}) {
  return (
    <div className="flex flex-wrap items-end gap-2">
      <label className="text-xs text-neutral-600">
        <span className="block mb-1">From</span>
        <input type="date" className={inputClass} value={from} max={to} onChange={e => setFrom(e.target.value)} />
      </label>
      <label className="text-xs text-neutral-600">
        <span className="block mb-1">To</span>
        <input type="date" className={inputClass} value={to} min={from} onChange={e => setTo(e.target.value)} />
      </label>
    </div>
  );
}

export function Notice({ tone = 'info', children }: { tone?: 'info' | 'warn' | 'error'; children: ReactNode }) {
  const cls = tone === 'error'
    ? 'bg-red-50 border-red-200 text-red-700'
    : tone === 'warn' ? 'bg-amber-50 border-amber-200 text-amber-800' : 'bg-sky-50 border-sky-200 text-sky-800';
  return <div className={`rounded-lg border p-3 text-sm ${cls}`}>{children}</div>;
}
